import AuthorizeGate from "@/modules/authorize/gate";

export default function Header() {
  return (
    <div className="pb-4">
      <h1 className="mb-2 text-2xl font-medium">Projects</h1>
      <p className="mt-1 text-gray-500">
        Projects overview.{" "}
        <AuthorizeGate>
          Click “Create project” below to add more projects.
        </AuthorizeGate>
      </p>
    </div>
  );
}
